import styled from "styled-components";

export const TOAST_CONTAINER_CLASSNAME = "toast";
const TOAST_BOTTOM_OFFSET = "12px";

export const IconContainer = styled.div(() => ({
    display: "flex",
}));

export const ToastContainer = styled.div(({ theme }) => ({
    [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
        bottom: `calc(var(--cart-footer-height, 0px) + ${TOAST_BOTTOM_OFFSET});`,
        left: theme.spacing.medium,
        right: theme.spacing.medium,
        zIndex: 9,
    },
}));
